var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "emd-panel__section eu-mb_4" }, [
    _c("div", { staticClass: "emd-panel__block" }, [
      _c(
        "div",
        { staticClass: "el-chunk" },
        [
          _c(
            "emd-text",
            { attrs: { tag: "h2", size: "medium", type: "caption" } },
            [_vm._v(_vm._s(_vm.$t("personal_data")) + " ")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "emd-panel__block" }, [
      _c(
        "div",
        { staticClass: "el-chunk" },
        [
          _c(
            "emd-text",
            {
              attrs: {
                size: "tiny",
                tag: "p",
                type: "label",
                "variation-color": "subtle",
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("name")) + " ")]
          ),
          _c("emd-text", { attrs: { size: "medium" } }, [
            _vm._v(
              _vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name)
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "el-chunk" },
        [
          _c(
            "emd-text",
            {
              attrs: {
                size: "tiny",
                tag: "p",
                type: "label",
                "variation-color": "subtle",
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("email")) + " ")]
          ),
          _c("emd-text", { attrs: { size: "medium" } }, [
            _vm._v(_vm._s(_vm.user.email)),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "el-chunk" },
        [
          _c(
            "emd-text",
            {
              attrs: {
                size: "tiny",
                tag: "p",
                type: "label",
                "variation-color": "subtle",
              },
            },
            [_vm._v(_vm._s(_vm.$t("permission")))]
          ),
          _c("emd-text", { attrs: { size: "medium", type: "caption" } }, [
            _vm._v(_vm._s(_vm.user.permission)),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "el-grid-list" }, [
        _c(
          "div",
          { staticClass: "el-chunk" },
          [
            _c(
              "emd-text",
              {
                attrs: {
                  size: "tiny",
                  tag: "p",
                  type: "label",
                  "variation-color": "subtle",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("phone")) + " ")]
            ),
            _c("emd-text", { attrs: { size: "medium" } }, [
              _vm._v(_vm._s(_vm.user.phone)),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "el-chunk" },
          [
            _c(
              "emd-text",
              {
                attrs: {
                  size: "tiny",
                  tag: "p",
                  type: "label",
                  "variation-color": "subtle",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("document")) + " ")]
            ),
            _c("emd-text", { attrs: { size: "medium" } }, [
              _vm._v(_vm._s(_vm.user.document_number)),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "el-grid-list" }, [
        _c(
          "div",
          { staticClass: "el-chunk" },
          [
            _c(
              "emd-text",
              {
                attrs: {
                  size: "tiny",
                  tag: "p",
                  type: "label",
                  "variation-color": "subtle",
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("create_date")) + " ")]
            ),
            _c("emd-text", { attrs: { size: "medium" } }, [
              _vm._v(_vm._s(_vm.user.created_at)),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }